module.exports = __webpack_public_path__ + "static/media/cheese-icon.a0156e98.png";